import React, { useState, useEffect, lazy, Suspense } from "react";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { Routes, Route } from "react-router-dom";
import {onAuthStateChanged } from "firebase/auth";
import {auth} from "./FirebaseConfig"
import "./App.css";
import Loader from "./components/Loader";
const Home = lazy(() => import("./pages/Home"));
const NotFound = lazy(() => import("./pages/NotFound"));
function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    try {
      const unregisterAuthObserver = onAuthStateChanged(auth, (user) => {
        if (user) {
          setUser(user);
          
        }
        setLoading(false)
      });
      return () => {
        unregisterAuthObserver();
        
      };
    } catch (error) {
      
    }
  }, []);
  useEffect(() => {
    loading? document.body.classList.add("loading"):document.body.classList.remove("loading")
  }, [loading]);

  return (
    <div className="App">
      <PayPalScriptProvider
        options={{ "client-id": process.env.REACT_APP_CLIENT }}
      >
        {loading && <Loader/>}
        <Suspense>

          <Routes>
            <Route path="/"element={<Home user={user} setUser={setUser} /> }/>
           
            <Route path="*"element={<NotFound/> }/>
          </Routes>
        </Suspense>
      </PayPalScriptProvider>
    </div>
  );
}

export default App;
